export enum ChatRole {
  USER = 'user',
  ASSISTANT = 'assistant',
}
